import * as React from 'react';
import { IState } from 'services/root-reducer';
import { getFavorites } from 'selectors';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { IObjectSignature } from 'types';
import { FavoritesDetalizationObject } from './detalization-object-item';
import './style.scss';

export interface IFormContentFavoritesDetalizationProps extends WithTranslation {
    favoritesData: IState[ 'favorites' ][ 'items' ];
}
export interface IFormContentFavoritesDetalizationState { }

export interface IDisplayConfigItem {
    TITLE: string;
    CONTAINER_CODE: string;
    ACTIVE_FIELD: string;
    FIELD_NAME: string;
    OBJ_TYPE_FIELD: string;
    CONTENT_URL: string;
}

const mapStateToProps = (state: IState) => ({
    favoritesData: getFavorites(state)
});

const VACANT_SITES_CODES = Object.freeze([ 'sites_1', 'sites_2', 'sites_3' ]);
const INVESTMENT_SITES_CODES = Object.freeze([ 'parks_3', 'parks_2', 'parks_1' ]);
const INVESTMENT_PROJECTS_CODES = Object.freeze([ 'projects_3', 'projects_2', 'projects_1' ]);
const OBJECTS_OF_DEVELOPMENT_PROGRAMS_CODES = Object.freeze([
    'programs_1',
    'programs_2',
    'programs_3',
    'programs_4',
    'programs_5',
    'programs_6'
]);

const FIELD_NAMES = new Map([
    [ VACANT_SITES_CODES, 'name' ],
    [ INVESTMENT_SITES_CODES, 'ia900' ],
    [ INVESTMENT_PROJECTS_CODES, 'ia350' ],
    [ OBJECTS_OF_DEVELOPMENT_PROGRAMS_CODES, 'ia397' ]
]);

/**
 * В этом файле одни зашивы по неизвестной причине. Как минимум получать названия
 * у объектов можно и другими способами. Пока на исправление этого нету времени.
 * @deprecated
 */
export function getNameColumn(layerCode: string) {
    for (let [ layerCodes, nameFieldCode ] of FIELD_NAMES.entries()) {
        if (layerCodes.indexOf(layerCode) !== -1) {
            return nameFieldCode;
        }
    }

    return '';
}

/* eslint-disable @typescript-eslint/indent */
class FormContentFavoritesDetalizationComponent extends React.Component<
    IFormContentFavoritesDetalizationProps,
    IFormContentFavoritesDetalizationState
    > {
    /* eslint-enable @typescript-eslint/indent */

    display_config: Map<ReadonlyArray<string>, IDisplayConfigItem>;

    constructor(props: IFormContentFavoritesDetalizationProps) {
        super(props);

        this.display_config = new Map([
            [
                VACANT_SITES_CODES,
                {
                    'TITLE': props.t('Избранные свободные инвестиционные площадки'),
                    'CONTAINER_CODE': 'investmap_layer_7531_copy',
                    'ACTIVE_FIELD': 'ia237',
                    'FIELD_NAME': FIELD_NAMES.get(VACANT_SITES_CODES),
                    'OBJ_TYPE_FIELD': 'ia720',
                    'CONTENT_URL': '/vacant-sites/'
                }
            ],
            [
                INVESTMENT_SITES_CODES,
                {
                    'TITLE': props.t('Избранные индустриальные парки'),
                    'CONTAINER_CODE': 'ia129',
                    'ACTIVE_FIELD': 'ia899',
                    'FIELD_NAME': FIELD_NAMES.get(INVESTMENT_SITES_CODES),
                    'OBJ_TYPE_FIELD': 'ia923',
                    'CONTENT_URL': '/investment-sites/'
                }
            ],
            [
                INVESTMENT_PROJECTS_CODES,
                {
                    'TITLE': props.t('Избранные проекты'),
                    'CONTAINER_CODE': 'ia14',
                    'ACTIVE_FIELD': 'ia351',
                    'FIELD_NAME': FIELD_NAMES.get(INVESTMENT_PROJECTS_CODES),
                    'OBJ_TYPE_FIELD': 'ia382',
                    'CONTENT_URL': '/investment-projects/'
                }
            ],
            [
                OBJECTS_OF_DEVELOPMENT_PROGRAMS_CODES,
                {
                    'TITLE': props.t('Избранные объекты программ развития'),
                    'CONTAINER_CODE': 'ia15',
                    'ACTIVE_FIELD': 'ia398',
                    'FIELD_NAME': FIELD_NAMES.get(OBJECTS_OF_DEVELOPMENT_PROGRAMS_CODES),
                    'OBJ_TYPE_FIELD': 'ia659',
                    'CONTENT_URL': '/objects-of-development-programs/'
                }
            ]
        ]);

        this.renderContent = this.renderContent.bind(this);
    }

    renderContent([ layer_codes, display_config ]: [ string[], IDisplayConfigItem ]) {
        let object_signatures = layer_codes.reduce<IObjectSignature[]>((ids, layer_code) => {
            if (layer_code in this.props.favoritesData) {
                let new_ids = this.props.favoritesData[layer_code];
                return [
                    ...ids,
                    ...new_ids.map(object_id => ({ layer_code, object_id }))
                ];
            } else {
                return ids;
            }
        }, []);

        if (object_signatures.length === 0) {
            return null;
        }

        return (
            <div className="detalization-item" key={display_config.TITLE}>
                <div className="detalization-item-name">
                    {display_config.TITLE}
                </div>

                <div className="detalization-item-objects-wrapper">
                    {object_signatures.map(signature => (
                        <FavoritesDetalizationObject
                            key={`${signature.layer_code}_${signature.object_id}`}
                            objectSignature={signature}
                            displayConfig={display_config}
                        />
                    ))}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="form-favorites-detalization">
                {[ ...this.display_config.entries() ].map(this.renderContent)}
            </div>
        );
    }
}

export const FormContentFavoritesDetalization = withTranslation()(
    connect(mapStateToProps)(
        FormContentFavoritesDetalizationComponent
    )
);
